import AbcIcon from '@mui/icons-material/Abc';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
  Avatar,
  Box,
  Button,
  CssBaseline,
  Grid,
  IconButton,
  Paper,
  Stack,
  ThemeProvider,
  Typography,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { createTheme } from '@mui/material/styles';
import { styled } from '@mui/system';
import axios from 'axios';
import { Form, Formik } from 'formik';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

import * as Yup from 'yup';
import { tokens } from '../../../src/tokens';

import { baseUrlApp } from '../../../next-sitemap.config';

const BlockTypo = styled(Typography)(() => ({
  fontFamily: 'play',
  opacity: 1,
  fontSize: '1.50rem',
  fontWeight: 700,
  lineHeight: '2.00rem',
  textAlign: 'center',
  paddingLeft: 0,
  whiteSpace: 'wrap',
  color: tokens.palette_secondary,
}));

const SignInButton = styled(Button)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.8750em',
  fontWeight: 500,
  textTransform: 'none',

  color: '#fff',
  border: `1px, solid  #0A2B3B`,
  backgroundColor: '#0A2B3B',
  '&:hover': {
    backgroundColor: '#FF7E24',
  },
}));

const defaultTheme = createTheme();

function AgentLogin() {
  const baseUrl = baseUrlApp;

  const router = useRouter();

  const [showPassword, setShowPassword] = useState(false);
  const [loginResponse, setLoginResponse] = useState({});
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  // formik LoginSchema define
  const LoginSchema = Yup.object().shape({
    username: Yup.string()
      .min(3, 'Username must be 3 characters at minimum')
      .required('Username is required'),
    password: Yup.string()
      .min(3, 'Password must be 3 characters at minimum')
      .required('Password is required'),
  });

  //  login api call
  const loginDataSubmit = (data) => {
    const payload = {
      username: data.username,
      password: data.password,
    };
    axios
      .post('/api/agents/login', payload)
      .then((response) => {
        console.log('response', response);
        localStorage.setItem('agent_login_token', response.data.token);
        localStorage.setItem('agent_username', response.data.agentName);
        setLoginResponse(response.data);
        if (response.data.status == true) {
          router.push('/blockquiry_connect/agency/message_app');
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // custom input style
  const CustomTextField = styled(TextField)({
    '& label.Mui-focused': {
      color: '#0B2B3B',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#0B2B3B',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#AFABAC',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#0B2B3B',
      },
    },
    input: {
      height: '50px',
      padding: '0 0 0 5px',
    },
  });

  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={6}
          sx={{
            backgroundImage: `url("/b_login_screen.png")`,
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#fff',
            backgroundSize: 'fit',
            backgroundPosition: 'center',
          }}
        />

        <Grid
          item
          xs={12}
          sm={8}
          md={6}
          component={Paper}
          //   variant="outlined"
          elevation={0}
          square
          sx={{ marginTop: '150px', marginBottom: '150px' }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Paper
              variant="outlined"
              elevation={0}
              sx={{
                display: 'block',
                flexDirection: 'column',
                alignItems: 'center',
                my: { xs: '24px', md: '24px' },
                p: { xs: '16px', md: '24px' },
                borderRadius: '8px',
                width: { xs: '365px', md: '465px' },
              }}
            >
              <Stack
                direction="row"
                spacing={0.25}
                sx={{
                  display: 'flex',

                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Avatar
                  variant="rounded"
                  sx={{
                    bgcolor: 'transparent',
                    border: '1px solid',
                    borderColor: tokens.token_grey_300,
                    width: '28px',
                    height: '28px',
                  }}
                >
                  <BlockTypo>b</BlockTypo>
                </Avatar>
                <BlockTypo
                  sx={{
                    color: tokens.palette_primary,
                    lineHeight: '1.75rem',
                    letterSpacing: 'normal',
                  }}
                >
                  connect
                </BlockTypo>
              </Stack>
              <Typography
                sx={{
                  color: '#202124',
                  fontFamily:
                    'Google Sans, Noto Sans Myanmar UI, arial, sans-serif',
                  fontSize: '24px',
                  fontWeight: 400,
                  lineHeight: '1.333rem',
                  wordBreak: 'break-word',
                  my: '16px',
                  textAlign: 'center',
                }}
              >
                Sign in
              </Typography>
              <Box sx={{ width: '100%' }}>
                <Formik
                  initialValues={{ username: '', password: '' }}
                  validationSchema={LoginSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                    loginDataSubmit(values);
                  }}
                >
                  {({ touched, errors, values, handleChange, handleBlur }) => (
                    <Form>
                      <CustomTextField
                        id="username"
                        name="username"
                        label="User name"
                        iconEnd={<AbcIcon />}
                        error={touched.username && errors.username}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AccountCircleOutlinedIcon />
                            </InputAdornment>
                          ),
                          style: {
                            height: '45px',
                            borderRadius: '4px',
                          },
                        }}
                        value={values.username}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        sx={{
                          height: '45px',
                          width: '100%',
                          marginTop: '35px',
                        }}
                      />
                      {errors.username && touched.username && (
                        <Box
                          sx={{ color: 'red', marginTop: '5px', width: '100%' }}
                        >
                          {errors.username}
                        </Box>
                      )}

                      <CustomTextField
                        id="password"
                        name="password"
                        type={showPassword ? 'text' : 'password'}
                        iconEnd={
                          showPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )
                        }
                        label="Password"
                        iconStart={<AbcIcon />}
                        error={touched.password && errors.password}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockOutlinedIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <VisibilityOffIcon />
                                ) : (
                                  <VisibilityIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                          style: {
                            height: '45px',
                            borderRadius: '4px',
                          },
                        }}
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        sx={{
                          height: '45px',
                          width: '100%',
                          marginTop: '35px',
                        }}
                      />
                      {errors.password && touched.password && (
                        <Box
                          sx={{ color: 'red', marginTop: '5px', width: '100%' }}
                        >
                          {errors.password}
                        </Box>
                      )}

                      {loginResponse.status == false ? (
                        <Typography
                          sx={{
                            color: 'red',
                            marginTop: '8px',
                            fontWeight: '500',
                          }}
                        >
                          {loginResponse.message}
                        </Typography>
                      ) : (
                        ''
                      )}

                      <SignInButton
                        type="submit"
                        fullWidth
                        sx={{ mt: '40px', mb: '8px' }}
                      >
                        Sign In
                      </SignInButton>
                    </Form>
                  )}
                </Formik>
              </Box>
            </Paper>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default AgentLogin;
